import React from "react";

import { OrgData } from "@types";

import { DarkBanner } from "./common";

type Props = {
  org: OrgData | undefined;
};

export const TrialBanner: React.FC<Props> = ({ org }) => {
  if (!org) return <div />;
  const features = org.features || [];
  const trialFeature = features.find((f) => f.name === "hasTeamsTierTrial");
  let trialText =
    "Your organization is currently on a trial of Semgrep Team tier";
  if (trialFeature && trialFeature.expires_at) {
    const expiration = new Date(parseInt(trialFeature.expires_at) * 1000);
    trialText = `Your Semgrep Team trial expires ${expiration.toLocaleDateString(
      "en-US",
      { year: "numeric", month: "long", day: "numeric" }
    )}`;
  }
  return <DarkBanner>{trialText}</DarkBanner>;
};
